import type { RouteKey } from '@/router/routesPathConfig';
import type { CompanyDashboardDestinationKey } from '@/abilities/companyDashboard/vocabulary';

/** The route that shows each place of the company dashboard. */
export const companyDashboardDestinationRoutes: Record<CompanyDashboardDestinationKey, RouteKey> = {
  root: 'COMPANY_DASHBOARD',
  vendorExpenses: 'COMPANY_DASHBOARD_VENDOR_EXPENSES',
};
